import { persistReducer, PersistConfig } from 'redux-persist';
import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import authReducer from './authReducer';
import clientReducer from './clientReducer';
import planReducer from './planReducer';
import promoCodeReducer from './promoCodeReducer';
import paymentReducer from './paymentReducer';
import agentReducer from './agentReducer';
import settingsReducer from './settingsReducer';
import websiteFormReducer from './websiteFormReducer';
import voterSignReducer from './voterSignReducer';
import clientSubscriptionReducer from './clientSubscriptionReducer';
import pollingScheduleReducer from './pollingScheduleReducer';
import partnerReducer from './partnerReducer';
import partnerOrderReducer from './partnerOrderReducer';
import commissionSettingsReducer from './commissionSettingsReducer';
import partnerCodeSettingsReducer from './partnerCodeSettingsReducer';
import trialSettingsReducer from './trialSettingsReducer';
import commissionRuleReducer from './commissionRuleReducer';
import commissionLedgerReducer from './commissionLedgerReducer';
import commissionSummaryReducer from './commissionSummaryReducer';
import payoutReducer from './payoutReducer';
import unconfiguredOrderReducer from './unconfiguredOrderReducer';
import kycSettingsReducer from './kycSettingsReducer';
import kycQueueReducer from './kycQueueReducer';
import locationRequestReducer from './locationRequestReducer';
import walletReducer from './walletReducer';
import materialReducer from './materialReducer';
import { RootState } from '../types/rootTypes';

const persistConfig: PersistConfig<RootState> = {
  key: 'electionsetu-root',
  storage,
  whitelist: ['auth', 'settings'],
  blacklist: [
    'clients',
    'plans',
    'promoCodes',
    'payments',
    'agents',
    'websiteForms',
    'voterSigns',
    'clientSubscriptions',
    'pollingSchedules',
    'partners',
    'partnerOrders',
    'commissionSettings',
    'partnerCodeSettings',
    'trialSettings',
    'commissionRules',
    'commissionLedger',
    'commissionSummary',
    'payouts',
    'unconfiguredOrders',
    'kycSettings',
    'kycQueue',
    'locationRequests',
    'wallet',
    'material',
  ],
};

const rootReducer = combineReducers({
  auth: authReducer,
  clients: clientReducer,
  plans: planReducer,
  promoCodes: promoCodeReducer,
  payments: paymentReducer,
  agents: agentReducer,
  settings: settingsReducer,
  websiteForms: websiteFormReducer,
  voterSigns: voterSignReducer,
  clientSubscriptions: clientSubscriptionReducer,
  pollingSchedules: pollingScheduleReducer,
  partners: partnerReducer,
  partnerOrders: partnerOrderReducer,
  commissionSettings: commissionSettingsReducer,
  partnerCodeSettings: partnerCodeSettingsReducer,
  trialSettings: trialSettingsReducer,
  commissionRules: commissionRuleReducer,
  commissionLedger: commissionLedgerReducer,
  commissionSummary: commissionSummaryReducer,
  payouts: payoutReducer,
  unconfiguredOrders: unconfiguredOrderReducer,
  kycSettings: kycSettingsReducer,
  kycQueue: kycQueueReducer,
  locationRequests: locationRequestReducer,
  wallet: walletReducer,
  material: materialReducer,
});

export default persistReducer(persistConfig, rootReducer);
